<template>
  <div class="flex">
    <div class="margin-right-40">
      <!-- 用户指标 -->
      <leftIndicators :userList="userIndicatorsList" :bigtitle="userIndicatorsTitle"/>
      <!-- 用户新增 -->
      <UserAddEchart/>
      <!-- 车辆指标 -->
      <leftIndicators :userList="carIndicatorsList" :bigtitle="carIndicatorsTitle"/>
      <!-- 车辆新增 -->
      <CarAddEchart/>
    </div>
    <div class="margin-right-xl">
      <taskIndicators :userList="userList"/>  
      <EvaluationIndicators :userList="userList"/>
      <div class="flex justify-between">
        <OperateIncome/>
        <OperateCount/>
        <ChangeBatteryLine/>
      </div>
      <OperationalIndicators :userList="userList"/>
      <div class="flex justify-between">
        <BatteryWarranty/>
        <LoadRateBar/>
        <LoadRatePie/>
      </div>
    </div>
    
  </div>
</template>

<script>
// 用户新增及活跃趋势
import UserAddEchart from "@/components/echart/siteCharts/userAddChart.vue";
// 车辆新增及活跃趋势
import CarAddEchart from "@/components/echart/siteCharts/carAddChart.vue";
// 运营业务收入
import OperateIncome from "@/components/echart/siteCharts/operateIncome.vue";
//运营站点数
import OperateCount from "@/components/echart/siteCharts/operateCount.vue";
//站点负荷率分布
import LoadRatePie from "@/components/echart/siteCharts/loadRatePie.vue";
//日均站点负荷率
import LoadRateBar from "@/components/echart/siteCharts/loadRateBar.vue";
//日均站点负荷率
import ChangeBatteryLine from "@/components/echart/siteCharts/changeBatteryLine";
//用户指标
import leftIndicators from "@/components/common/leftIndicators";
//任务指标
import taskIndicators from "@/components/common/taskIndicators";
//考核指标
import EvaluationIndicators from "@/components/common/evaluationIndicators";
//运营指标
import OperationalIndicators from "@/components/common/operationalIndicators";
//电池质保
import BatteryWarranty from "@/components/common/batteryWarranty";
//综合态势
// import Overview from "@/components/common/overview";

import { indexLeft } from '@/api/indexLeft';
import { dataInterface } from '@/api/dataInterfaceApi';



export default {
  data () {
    return {
      options: {},
      // 用户指标
      //标题
      userIndicatorsTitle:{
        CHN:'用户指标',
        ENG:'User indicators'
      },
      //展示数据
      userIndicatorsList:[{
        counts:0,
        text:"入网用户数"
      },{
        counts:0,
        text:"注册用户数"
      },{
        counts:0,
        text:"本月新增入网司机"
      },{
        counts:0,
        text:"本月换电活跃司机"
      }],
      //车辆指标
      //标题
      carIndicatorsTitle:{
        CHN:'车辆指标',
        ENG:'Car indicators'
      },
      //展示数据
      carIndicatorsList:[{
        counts:0,
        text:"换电车辆数"
      },{
        counts:0,
        text:"单车日均换电次数"
      },{
        counts:0,
        text:"本月新增车辆数"
      },{
        counts:0,
        text:"单车日均换电里程"
      }],
      userList:[{},{},{},{}],
      //用户指标
      selectUserTarget:{},
    };
  },
  components: {
    UserAddEchart,
    CarAddEchart,
    OperateIncome,
    OperateCount,
    LoadRatePie,
    leftIndicators,
    LoadRateBar,
    taskIndicators,
    EvaluationIndicators,
    OperationalIndicators,
    BatteryWarranty,
    ChangeBatteryLine,
    // Overview
  },
  props: {
    cdata: {
      type: Object,
      default: () => ({})
    },
  },
  watch: {
    
  },
  mounted () {
    
  },
  methods: {
    // 刷新接口需要每个子组件封装一个getData();
    getData(data){
      this.yonghuzhibiao(data);
      this.benyueyonghu(data);
      this.getCarTarget(data);
    },
    //数据接口
		yonghuzhibiao(data={}){
      let _this = this;
			let params = {};
			if(data){
				// TiDB-省市区-用户指标
				params = {
					"enCode":"TiDB-shengshiqu-yonghuzhibiao",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-yonghuzhibiao"// TiDB-全国-用户指标
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
            res = res[0];
            _this.$set(this.userIndicatorsList,0,{
              counts:res.AccessUser||0,
              text:"累计入网用户数"
            })
            _this.$set(this.userIndicatorsList,1,{
              counts:res.RegisterUser||0,
              text:"累计注册用户数"
            })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //本月换电活跃用户
    benyueyonghu(data={}){
      let _this = this;
			let params = {};
			if(data){
				//省市区
				params = {
					"enCode":"TiDB-shengshiqu-benyueyonghu",
    			"@province":data.province||data.city||data.district
				}
			}else {
				params = {
					"enCode":"TiDB-quanguo-benyueyonghu"//TiDB-全国-本月用户
				}
			}
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          console.log(res);
          _this.$set(this.userIndicatorsList,2,{
            counts:res.NewUser,
            text:"本月新增入网司机"
          })
          _this.$set(this.userIndicatorsList,3,{
            counts:res['MonthlyActiveUsers']||0,
            text:"本月换电活跃司机"
          })
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCarTarget(data={}){
      let _this = this;
      let params = {};
      if(data){
        //省市区
        params = {
          "enCode":"TiDB-shengshiqu-cheliangzhibiao",
          "@province":data.province||data.city||data.district
        }
      }else {
        params = {
          "enCode":"TiDB-quanguo-cheliangzhibiao"//全国
        }
      }
      dataInterface
        .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          _this.carIndicatorsList = [{
            counts:res.changePowerVehicleNum||0,
            text:"本月换电车辆数"
          },{
            counts:res['changePowerNum']||0,
            text:"单车日均换电次数"
          },{
            counts:res['addVehicleNum']||0,
            text:"本月新增车辆数"
          },{
            counts:res['changePowerCourse']||0,
            text:"单车日均换电里程"
          }];
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;
}
</style>